
import CLink from "./CLink";
import { motion } from 'framer-motion';

type ProblemType = {
    id: string;
    title: string;
    description: string;
    difficulty: string;
    type: string;
    public: boolean;
    selected: boolean;
    onClick: () => void;
};

export default function ProblemCard(props: ProblemType) {

    return (
        <motion.div 
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25, delay: 0.1 }}
        >
            <CLink 
                to={`/code/${props.id}`} 
                target="_blank" 
                className={`problem ${props.selected && 'selected'}`} 
                key={props.id}
            >
                <div className="details">
                    <div className="title">{props.title}</div>
                    <div className="description">
                        {(props.description.length > 30) ? props.description.slice(0, 30) + "..." : props.description}
                    </div>
                    <div className='badges'>
                        <span className={`difficulty ${props.difficulty}`}>{props.difficulty}</span>
                        <span className={`type ${props.type}`}>{props.type}</span>
                        <span className={`visibility ${props.public ? 'public' : 'private'}`}>{props.public ? "public" : "private"}</span>
                    </div>
                </div>
                <button
                    className={(props.selected) ? "selected" : ""} 
                    onClick={(e) => {
                        e.preventDefault(); 
                        props.onClick();
                    }}>
                    {
                        (props.selected) ? "Remove" : "Add"
                    }
                </button>
            </CLink>
        </motion.div>
    )
}